export default __webpack_public_path__ + "static/media/tikilogo.b2630c27.svg";